import { PaginationRequest } from '../config/common';

export class PaginationFailureReasonRequest extends PaginationRequest {
    failureReason?: string = '';
}

export interface CreateFailureReasonRequest {
    failureReason?: string;
}
